import axios from "axios";
import React, { useEffect, useMemo, useRef, useState } from "react";
import SelectorMulti from "../components/SelectorMulti";
import { colorCodes } from "../utils/color";
import { attributeNames, dimensionNames } from "../utils/variables";

import BeatLoader from "react-spinners/BeatLoader";
import SyncLoader from "react-spinners/SyncLoader";

import RadarGraphCombo from "../components/charts/RadarGraphBlenderCombo";

import { useAnalyticsEventTracker } from "../components/Tracker";

import imgBg from "../assets/eDNA_Blender_Background1.jpg";
import ednaBlenderLogo from "../assets/eDNA_Blender_BETA_Lockup_eDNA_Blender_Full_white.png";

import InfiniteScroll from "react-infinite-scroll-component";

import { BiFilter } from "react-icons/bi";
import { CgCloseO } from "react-icons/cg";

import ResultList from "../components/ResultList";
import UnitIngred from "../components/UnitIngred";
import UnitResult from "../components/UnitResult";
import ViewModeIcons from "../components/ViewModeIcons";

import IngredSmall from "../components/IngredSmall";
import WhatIseDNA from "../components/WhatIseDNA";
import {
  calcAttDistance,
  getDbThres,
  getProximityUnscripted,
} from "../utils/unscriptedProximity";

import { Checkbox } from "@mui/material";

function Blender() {
  const gaEventTrackerContent = useAnalyticsEventTracker("Ingredients");

  // Grab last database data stored in backend
  const [dbData, setDbData] = useState([{}]);
  const [dbContentList, setDbContentList] = useState([{}]);
  const [dbPlatformList, setDbPlatformList] = useState([{}]);

  let { attMinDict, attMaxDict } = getDbThres(dbData, 30, 70);

  // Loading content data when page starts
  useEffect(() => {
    const runCall = async () => {
      let apiValue = await fetchData();
      setDbContentList(JSON.parse(apiValue.db_content_list));

      setDbPlatformList(JSON.parse(apiValue.db_platform_list));

      setDbData(JSON.parse(apiValue.db_most_recent));

      return null;
    };

    const fetchData = async () => {
      const apiUrl = process.env.REACT_APP_BACKEND_URL + "/media/db_save.json";
      try {
        const response = (await axios.get(apiUrl)).data;
        return response;
      } catch (err) {
        console.log(err);
        return null;
      }
    };
    runCall();
  }, []);

  // Prepare data for radar chart
  const dimPctInit = {};
  for (var j = 0; j < 8; j++) {
    dimPctInit[dimensionNames[j] + "_pct"] = 0;
  }

  // Found proximity
  const returnProximityInit = [
    Object.assign({}, { rank: 0, show_name: "" }, dimPctInit),
  ];

  // Select blender ingredients
  const [selectedOption, setSelectedOption] = useState(returnProximityInit);
  const handleSelectorChange = (selectingOption) => {
    setSelectedContent(selectingOption);

    // Reset goClicked & blender results
    setGoClicked(false);
    setBlenderData(blenderDataInit);
    setBlenderDataDisplay(blenderDataInit);

    const selectUpdate = selectingOption.map((selection, index) => {
      const tempDict = {};

      var tempId = selectingOption[index].django_id;
      var tempName = selectingOption[index].label;
      var tempPoster = selectingOption[index].poster_link;
      var tempGenre = dbData[tempId].genres;
      var tempRating = dbData[tempId].evaluation_score;
      var tempIntent = dbData[tempId].intentionality;

      tempDict["django_id"] = tempId;
      tempDict["name"] = tempName;
      tempDict["poster_link"] = tempPoster;
      tempDict["genres"] = tempGenre;
      tempDict["rating"] = tempRating;
      tempDict["intentionality"] = tempIntent;

      dimensionNames.map((dim, i) => {
        tempDict[dim] = dbData[tempId][dim];
        tempDict[dim + "_pct"] = dbData[tempId][dim + "_pct"];
        return tempDict;
      });

      attributeNames.map((att, i) => {
        tempDict[att] = dbData[tempId][att];
        return tempDict;
      });

      return tempDict;
    });

    // Update selected content
    if (selectUpdate.length === 0) {
      setSelectedOption(returnProximityInit);
    } else {
      setSelectedOption(selectUpdate);
    }

    // Scroll to view complete ingredients
    if (window.innerWidth > 768) {
      setTimeout(function () {
        ingredientsListRef.current?.scrollIntoView({ behavior: "smooth" });
        // }
      }, 100);
    }
  };

  const handleIncLowCheck = (event: React.ChangeEvent<HTMLInputElement>) => {
    // Hide radar charts
    // setShowRadar(false);

    // Reset goClicked & blender results
    setGoClicked(false);
    setBlenderData(blenderDataInit);

    // Clear previous selection
    // setSelectedOption([]);

    var checked = event.target.checked;
    setIncLowChecked(checked);
    // if (checked) {
    //   // console.log('include low reach checked!')
    //   setDbContentList(dbContentListNoAnime);
    // } else {
    //   // console.log('no low reach!')
    //   setDbContentList(dbContentListReach);
    // }
  };

  const handleSelectorChangeResultFilter = (selectingOption, name) => {
    // Scroll to have posters view
    setTimeout(function () {
      resultPosterRef.current?.scrollIntoView({ behavior: "smooth" });
    }, 100);

    var filterContentTypeTemp = filterContentType;
    // var filterGenreTemp = filterGenre;
    var filterGenreTemp = allGenres;
    var filterNetworkTemp;
    if (filterNetwork === 0) {
      setFilterNetwork(filterNetworkInit);
      filterNetworkTemp = filterNetworkInit;
    } else {
      filterNetworkTemp = filterNetwork;
    }
    var filterRatingTemp = filterRating;
    var filterReachTemp = filterReach;

    const topQuartile = name.fromCheckbox ? name.topQuartileState : selectedTopQuartile;


    // Set values to empty array when cross is clicked
    var removeTarget = "";
    if (!name?.fromCheckbox) {
        if (selectingOption.length === 0) {
        if (name.action === "clear") {
          removeTarget = name.removedValues[0].tag;
        } else {
          removeTarget = name.removedValue.tag;
        }

        if (removeTarget === "contentType") {
          setSelectedContentTypeResult([]);
          setFilterContentType(filterContentTypeInit);
          setFilterGenre(filterGenreInit);
          filterContentTypeTemp = filterContentTypeInit;
        } else if (removeTarget === "genre") {
          setSelectedGenreResult([]);
          setFilterGenre(filterGenreInit);
          filterGenreTemp = filterGenreInit;
        } else if (removeTarget === "network") {
          setSelectedNetworkResult([]);
          setFilterNetwork(filterNetworkInit);
          filterNetworkTemp = filterNetworkInit;
        } else if (removeTarget === "rating") {
          setSelectedRatingResult([]);
          setFilterRating(filterRatingInit);
          filterRatingTemp = filterRatingInit;
        } else if (removeTarget === "reach") {
          setSelectedReachResult([]);
          setFilterReach(filterReachInit);
          filterReachTemp = filterReachInit;
        }
      } else {
        if (selectingOption[0].tag === "contentType") {
          setSelectedContentTypeResult(selectingOption);
          filterContentTypeTemp = [];
          selectingOption.map((option, index) =>
            filterContentTypeTemp.push(option.value)
          );
          setFilterContentType(filterContentTypeTemp);

          if (
            filterContentTypeTemp.length === 1 &&
            filterContentTypeTemp.includes("Movie")
          ) {
            setDisableGenreFilter(true);
          }
        } else if (selectingOption[0].tag === "genre") {
          setSelectedGenreResult(selectingOption);
          filterGenreTemp = [];
          selectingOption.map((option, index) =>
            filterGenreTemp.push(option.value)
          );
          setFilterGenre(filterGenreTemp);
        } else if (selectingOption[0].tag === "network") {
          setSelectedNetworkResult(selectingOption);
          filterNetworkTemp = [];
          selectingOption.map((option, index) =>
            filterNetworkTemp.push(option.value)
          );
          setFilterNetwork(filterNetworkTemp);
        } else if (selectingOption[0].tag === "rating") {
          setSelectedRatingResult(selectingOption);
          filterRatingTemp = [];
          selectingOption.map((option, index) =>
            filterRatingTemp.push(option.value)
          );
          setFilterRating(filterRatingTemp);
        } else if (selectingOption[0].tag === "reach") {
          setSelectedReachResult(selectingOption);
          filterReachTemp = [];
          selectingOption.map((option, index) =>
            filterReachTemp.push(option.value)
          );
          setFilterReach(filterReachTemp);
        }
      }
    }
    

    // // Check content type filter (Movie only -> disable genre filter)
    // if (
    //   filterContentTypeTemp.length === 1 &&
    //   filterContentTypeTemp.includes("Movie")
    // ) {
    //   setSelectedGenreResult([]);
    //   setDisableGenreFilter(true);
    //   setFilterGenre(filterGenreInit);
    //   filterGenreTemp = filterGenreInit;
    // } else if (filterContentTypeTemp.length === 2) {
    //   setDisableGenreFilter(false);
    // }

    // 1. BlenderDataAll -> filter by network selected
    var blenderDataFilterContentType = blenderDataAll.filter(function (el) {
      return filterContentTypeTemp.indexOf(el.content_type) > -1;
    });

    var blenderDataFilterGenre = blenderDataAll.filter(function (el) {
      // return filterGenreTemp.indexOf(el.genres) > -1;
      return filterGenreTemp.some((genre) =>
        el.genres
          ?.split(",")
          .map((g) => g.trim())
          .includes(genre)
      );
    });

    var blenderDataFilterNetwork = blenderDataAll.filter(function (el) {
      var networks = [];
      if (el.current_network_ids) {
        el.current_network_ids.map((id) => networks.push(parseInt(id)));
      } else {
        networks.push(0);
      }
      return filterNetworkTemp.filter((x) => networks.includes(x)).length > 0;
    });

    var blenderDataFilterRating = blenderDataAll.filter(function (el) {
      return (
        filterRatingTemp.indexOf(Math.floor(el.evaluation_score).toFixed(0)) >
        -1
      );
    });

    var blenderDataFilterReach = blenderDataAll.filter(function (el) {
      // return (
      //   el.incidence_rate >= filterReach[0] &&
      //   el.incidence_rate <= filterReach[1]
      // );
      const rate = Number(el.incidence_rate);

      return filterReachTemp.some((val) => {
        if (val === 0) return rate > 0;
        if (val === "2") return rate < 2;
        if (val === "5") return rate >= 2 && rate < 5;
        if (val === "10") return rate >= 5 && rate < 10;
        if (val === "20") return rate >= 10 && rate < 20;
        if (val === "40") return rate >= 20;
        return false;
      });
    });

    var blenderDataFilterTopQuartile = blenderDataAll.filter((el) => {
      // If no top quartile selected, return everything from the original blenderDataAll
      if (!topQuartile.contentAcquisition && !topQuartile.evaluation) {
        return true;
      }
      let keep = true;
      if (topQuartile.contentAcquisition) keep = keep && el.top_q_pay_exclusive === 1;
      if (topQuartile.evaluation) keep = keep && el.top_q_evaluation_score === 1;
      return keep;
    });


    var blenderDataFilterFinal = [
      blenderDataFilterContentType,
      blenderDataFilterGenre,
      blenderDataFilterNetwork,
      blenderDataFilterRating,
      blenderDataFilterReach,
      blenderDataFilterTopQuartile,
    ].reduce((a, b) => a.filter((c) => b.includes(c)));
    setFinalResult(blenderDataFilterFinal);

    // console.log("blenderDataFilterContentType", blenderDataFilterContentType);
    // console.log("blenderDataFilterGenre", blenderDataFilterGenre);
    // console.log("blenderDataFilterNetwork", blenderDataFilterNetwork);
    // console.log("blenderDataFilterRating", blenderDataFilterRating);
    // console.log("blenderDataFilterReach", blenderDataFilterReach);

    // console.log("blenderDataFilterTopQuartile",blenderDataFilterTopQuartile)

    // console.log("blenderDataFilterFinal", blenderDataFilterFinal);
    

    setdisplayCount(10);

    if (blenderDataFilterFinal.length === 0) {
      setBlenderData(blenderDataInit);
      setBlenderDataDisplay(blenderDataInit);
    } else {
      setBlenderData(blenderDataFilterFinal);
      setBlenderDataDisplay(blenderDataFilterFinal.slice(0, 10));
    }
  };

    const handleTopQuartileCheck = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, checked } = event.target;

    // Compute the new state
    const newTopQuartile = {
      ...selectedTopQuartile,
      [name]: checked,
    };

    // Update state
    setSelectedTopQuartile(newTopQuartile);

    // Pass the updated value to the filter
    handleSelectorChangeResultFilter([], { fromCheckbox: true, topQuartileState: newTopQuartile });
  };



  // Calculate blending result
  const selectedOptionIds = [];
  selectedOption.map((option, i) =>
    selectedOptionIds.push(option["django_id"])
  );

  // DIMENSIONS
  const dimSumDict = {};
  const dimAvgDict = {};
  dimensionNames.map((dim, index) => {
    // Collect all values for each dimension
    dimSumDict[dim] = [0];
    selectedOption.map((content, i) => dimSumDict[dim].push(content[dim]));

    // Calculate average
    const avg = (array) =>
      array.reduce((a, b) => a + b) / (dimSumDict[dim].length - 1);
    dimAvgDict[dim] = avg(dimSumDict[dim]);
    return dimAvgDict;
  });

  // ATTRIBUTES (for Unscripted)
  const attSumDict = {};
  const attAvgDict = {};
  attributeNames.map((att, index) => {
    // Collect all values for each dimension
    attSumDict[att] = [0];
    selectedOption.map((content, i) => attSumDict[att].push(content[att]));
    // Calculate average
    const avg = (array) =>
      array.reduce((a, b) => a + b) / (attSumDict[att].length - 1);
    attAvgDict[att] = avg(attSumDict[att]);
    return attAvgDict;
  });

  // Blender ingredients data
  var blenderDataInit = [{}];
  dimensionNames.map((dimension, index) => (blenderDataInit[0][dimension] = 0));
  blenderDataInit[0]["show_name"] = "";
  const [blenderData, setBlenderData] = useState(blenderDataInit);
  const [blenderDataAll, setBlenderDataAll] = useState(blenderDataInit);

  const allGenres =
    blenderDataAll.length > 1
      ? Array.from(
          new Set(
            blenderDataAll.flatMap((item) =>
              (item.genres || "")
                .split(",")
                .map((g) => g.trim())
                .filter((g) => g.length > 0)
            )
          )
        ).sort()
      : [];

  // Find proximity (GO btn)
  const [goClicked, setGoClicked] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const resetFilters = () => {
    setFilterContentType(filterContentTypeInit);
    setFilterGenre(filterGenreInit);
    setFilterNetwork(filterNetworkInit);
    setFilterRating(filterRatingInit);
    setFilterReach(filterReachInit);

    setSelectedTopQuartile({
      contentAcquisition: false,
      evaluation: false,
    });

    setSelectedContentTypeResult([]);
    setDisableGenreFilter(false);
    setSelectedGenreResult([]);
    setSelectedNetworkResult([]);
    setSelectedRatingResult([]);
    setSelectedReachResult([]);
  };
  const handleSubmitGo = (event) => {
    event.preventDefault();

    resetFilters();

    // Tracker
    gaEventTrackerContent(
      "Combo",
      selectedOptionNames
        .map(function (x) {
          return x.replace(/[*]$/, "");
        })
        .join("; ")
      //   selectedOptionIds
    );
    gaEventTrackerContent(
      "Combo Sort",
      selectedOptionNames
        .sort()
        .map(function (x) {
          return x.replace(/[*]$/, "");
        })
        .join("; ")
    );
    selectedOption.map((option, index) =>
      gaEventTrackerContent("Individual", option.name, option.django_id)
    );

    setGoClicked(true);
    setIsLoading(true);

    // Check if selectedContent contains any Unscripted
    // 2023.03.07 Use v2 approach for all blending
    var includeUnscripted = 1;
    // if (
    //   selectedContent.filter(function (el) {
    //     return el.genre === "Unscripted";
    //   }).length > 0
    // ) {
    //   includeUnscripted = 1;
    // }

    var dataSend;

    if (includeUnscripted === 1) {
      dataSend = Object.assign(dimAvgDict, attAvgDict);
    } else {
      dataSend = dimAvgDict;
    }

    dataSend["knob_type"] = "attribute";
    dataSend["content_type"] = [true, true, false]; //WILL FIX LATER! ONLY SHOWS NOW
    dataSend["include_low"] = incLowChecked;
    dataSend["selected_ids"] = selectedOptionIds;

    // console.log(selectedOption);

    // ==========================
    //      LOCAL COMPUTATION
    // ==========================

    var result = [];
    dbData
      .filter(function (el) {
        var incLow;
        if (incLowChecked) {
          // console.log("Include Low Reach");
          incLow = [0, 1];
        } else {
          // console.log("No Low Reach");
          incLow = [1];
        }
        if (
          ["Show", "Movie"].includes(el.content_type) &&
          ["Comedy", "Drama", "Unscripted", "-"].includes(el.genre) &&
          !selectedOptionIds.includes(el.django_id) &&
          [0].includes(el.anime) &&
          incLow.includes(el.reach_thres) &&
          (el.release_date > "1980-01-01" || el.release_date === null)
        ) {
          return 1;
        }
        return 0;
      })
      .map((record, index) => {
        var temp_distance;
        if (includeUnscripted === 0) {
          temp_distance = Math.sqrt(
            Math.pow(dataSend["originality"] - record["originality"], 2) +
              Math.pow(dataSend["relatability"] - record["relatability"], 2) +
              Math.pow(dataSend["adrenaline"] - record["adrenaline"], 2) +
              Math.pow(dataSend["gravity"] - record["gravity"], 2) +
              Math.pow(dataSend["passion"] - record["passion"], 2) +
              Math.pow(dataSend["smarts"] - record["smarts"], 2) +
              Math.pow(dataSend["levity"] - record["levity"], 2) +
              Math.pow(dataSend["heart"] - record["heart"], 2)
          );
        } else {
          var blendAtt = getProximityUnscripted(
            attMinDict,
            attMaxDict,
            selectedOption
          );
          temp_distance = calcAttDistance(blendAtt, record);
        }

        result.push({ ...record, distance: temp_distance });
        return result;
      });

    // Sort by distance
    result.sort((a, b) => (a.distance > b.distance ? 1 : -1));

    // Keep only first 300 results
    result = result.slice(0, 300);

    // console.log("RESULT", result);

    // const resultLog = [];
    // result.map((res) =>
    //   resultLog.push({ show_name: res.show_name, distance: res.distance })
    // );

    // console.log("resultData", resultLog);
    setBlenderData(result);
    setBlenderDataDisplay(result.slice(0, 10));
    setBlenderDataAll(result);

    // Filter blender data by exisiting result filters
    if (
      selectedGenreResult
        .concat(selectedNetworkResult)
        .concat(selectedRatingResult).length !== 0
    ) {
      var blenderDataFilterContentType = result.filter(function (el) {
        return filterContentType.indexOf(el.content_type) > -1;
      });

      var blenderDataFilterGenre = result.filter(function (el) {
        return filterGenre.indexOf(el.genre) > -1;
      });

      var blenderDataFilterNetwork = result.filter(function (el) {
        var networks = [];
        if (el.current_network_ids) {
          // el.current_network_ids.replace("[","").replace("]",).split(",").map(id => (
          el.current_network_ids.map((id) => networks.push(parseInt(id)));
        } else {
          networks.push(0);
        }
        return filterNetwork.filter((x) => networks.includes(x)).length > 0;
      });

      var blenderDataFilterRating = result.filter(function (el) {
        return (
          filterRating.indexOf(Math.floor(el.evaluation_score).toFixed(0)) > -1
        );
      });

      // const blenderDataFilteredReach = result.filter((item) => {
      //   const rate = item.incidence_rate;
      //   return rate >= filterReach[0] && rate <= filterReach[1];
      // });

      var blenderDataFilterFinal = [
        blenderDataFilterContentType,
        blenderDataFilterGenre,
        blenderDataFilterNetwork,
        blenderDataFilterRating,
      ].reduce((a, b) => a.filter((c) => b.includes(c)));
      // setFinalResult(blenderDataFilterFinal);

      if (blenderDataFilterFinal.length === 0) {
        setBlenderData(blenderDataInit);
        setBlenderDataDisplay(blenderDataInit);
      } else {
        setBlenderData(blenderDataFilterFinal);
        setBlenderDataDisplay(blenderDataFilterFinal.slice(0, 10));
      }
    } else {
    }

    // ============================
    //   END OF LOCAL COMPUTATION
    // ============================

    // Reset displayCount
    setdisplayCount(10);

    // Scroll to results
    setTimeout(function () {
      resultRef.current?.scrollIntoView({ behavior: "smooth" });
      setIsLoading(false);
      // }
    }, 1000);
  };

  const resultPosters = [];
  if (blenderData.length > 1) {
    blenderData.map((result, index) => resultPosters.push(result.poster_link));
  }

  // Data for radar chart plotting
  const radarChartData = [];
  selectedOption.map((option, index) => {
    radarChartData.push(
      dimensionNames.map((dimension, index) => ({
        subject: dimension.charAt(0).toUpperCase() + dimension.slice(1),
        Reference: option[dimension + "_pct"],
        fullMark: 100,
      }))
    );
    return radarChartData;
  });

  // Data for radar chart plotting from blender result (blenderData)
  const radarChartDataResult = [];
  blenderData.map((option, index) => {
    radarChartDataResult.push(
      dimensionNames.map((dimension, index) => ({
        subject: dimension.charAt(0).toUpperCase() + dimension.slice(1),
        Reference: option[dimension + "_pct"],
        fullMark: 100,
      }))
    );
    return radarChartDataResult;
  });

  const radarChartDataBlender = [];
  dimensionNames.map((dimension, index) => {
    var tempDict = {};
    tempDict["subject"] =
      dimension.charAt(0).toUpperCase() + dimension.slice(1);
    tempDict["fullMark"] = 100;
    for (let i = 0; i < blenderData.length; i++) {
      // for (let i=0; i<5; i++) {
      tempDict[i] = blenderData[i][dimension + "_pct"];
    }
    radarChartDataBlender.push(tempDict);
    return radarChartDataBlender;
  });

  // Scroll to bottom when show radar chart
  const bottomRef = useRef(null);
  const ingredientsListRef = useRef(null);
  const ingredientsRef1 = useRef(null);
  const ingredientsRef2 = useRef(null);
  const resultRef = useRef(null);
  const resultPosterRef = useRef(null);

  // Combo show_name
  var selectedOptionNames = [];
  selectedOption.map((option, index) => selectedOptionNames.push(option.name));

  // Handle switch beween including low reach content or no
  // const incLowChecked = false;
  const [incLowChecked, setIncLowChecked] = useState(false);

  const radarChartDataCombo = [];
  dimensionNames.map((dimension, index) => {
    var tempDict = {};
    tempDict["subject"] =
      dimension.charAt(0).toUpperCase() + dimension.slice(1);
    tempDict["fullMark"] = 100;

    radarChartData.map((ingred, j) => {
      tempDict[j] = ingred[index]["Reference"];
      return tempDict;
    });

    radarChartDataCombo.push(tempDict);
    return radarChartDataCombo;
  });

  // Btn for clearing all filters
  const filterContentTypeInit = ["Show", "Movie"];
  const filterGenreInit = ["Comedy", "Drama", "Unscripted", "-"];
  // const filterGenreInit = allGenres;
  const filterNetworkInit = [0];
  dbPlatformList.map((network, index) => filterNetworkInit.push(network.value));
  const filterRatingInit = ["1", "2", "3", "4", "5"];
  const filterReachInit = ["2", "5", "10", "20", "40"];

  const [filterContentType, setFilterContentType] = useState(
    filterContentTypeInit
  );
  const [filterGenre, setFilterGenre] = useState(filterGenreInit);
  const [filterNetwork, setFilterNetwork] = useState(0);
  const [filterRating, setFilterRating] = useState(filterRatingInit);
  const [filterReach, setFilterReach] = useState(filterReachInit);

  const [finalResult, setFinalResult] = useState([0]);

  const [disableGenreFilter, setDisableGenreFilter] = useState(false);
  const [selectedContentTypeResult, setSelectedContentTypeResult] = useState(
    []
  );
  const [selectedGenreResult, setSelectedGenreResult] = useState([]);
  const [selectedNetworkResult, setSelectedNetworkResult] = useState([]);
  const [selectedRatingResult, setSelectedRatingResult] = useState([]);
  const [selectedReachResult, setSelectedReachResult] = useState([]);
  const [selectedContent, setSelectedContent] = useState([]);

  const [selectedTopQuartile, setSelectedTopQuartile] = useState({
    contentAcquisition: false,
    evaluation: false,
  });
  


  const handleClearAll = (event) => {
    // Scroll to have posters view
    setTimeout(function () {
      resultPosterRef.current?.scrollIntoView({ behavior: "smooth" });

      // }
    }, 100);

    // event.preventDefault();
    setFilterContentType(filterContentTypeInit);
    setFilterGenre(filterGenreInit);
    setFilterNetwork(filterNetworkInit);
    setFilterRating(filterRatingInit);
    setFilterReach(filterReachInit);
    setSelectedTopQuartile({
      contentAcquisition: false,
      evaluation: false,
    })

    setdisplayCount(10);
    setFinalResult(blenderDataAll);
    setBlenderData(blenderDataAll);
    setBlenderDataDisplay(blenderDataAll.slice(0, 10));

    // Content Type filter
    setSelectedContentTypeResult([]);
    setDisableGenreFilter(false);

    // Genre filter
    setSelectedGenreResult([]);

    // Network filter
    setSelectedNetworkResult([]);

    // Rating filter
    setSelectedRatingResult([]);

    // Reach filter
    setSelectedReachResult([]);
  };

  // Handle condition render for white gradient backround
  function useIsInViewport(ref) {
    const [isIntersecting, setIsIntersecting] = useState(false);

    const observer = useMemo(
      () =>
        new IntersectionObserver(([entry]) =>
          setIsIntersecting(entry.isIntersecting)
        ),
      []
    );

    useEffect(() => {
      observer.observe(ref.current);

      return () => {
        observer.disconnect();
      };
    }, [ref, observer]);

    return isIntersecting;
  }
  const isInViewport1 = useIsInViewport(ingredientsRef1);
  const isInViewport2 = useIsInViewport(ingredientsRef2);
  const isInViewport3 = useIsInViewport(resultRef);

  // Handl close btn on ingredient posters
  const handleCloseBtn = (event, name) => {
    // Reset goClicked & blender results
    setGoClicked(false);
    setBlenderData(blenderDataInit);
    setBlenderDataDisplay(blenderDataInit);
    const updatedSelectedOption = selectedOption.filter(function (_, i) {
      return i !== name;
    });

    if (selectedOption.length === 1) {
      setSelectedOption(returnProximityInit);
    } else {
      setSelectedOption(updatedSelectedOption);
    }

    const updatedSelectedContent = selectedContent.filter(function (_, i) {
      return i !== name;
    });
    setSelectedContent(updatedSelectedContent);
  };

  // Handle number of rows of results in display
  const [displayCount, setdisplayCount] = useState(10);

  const [blenderDataDisplay, setBlenderDataDisplay] = useState(blenderDataInit);
  const fetchMoreData = () => {
    setTimeout(() => {
      setBlenderDataDisplay(
        blenderDataDisplay.concat(
          blenderData.slice(displayCount, displayCount + 10)
        )
      );
      setdisplayCount(displayCount + 10);
    }, 500);
  };

  // Handle grid or list view (small screen)
  const [viewMode, setViewMode] = useState("grid");


  return (
    <div className="flex-inline">
      {/* Top Part with Background Image */}
      <div
        className={`px-0 md:px-10
                             pt-24 pb-0 z-50 min-h-[600px]
                             shadow-[#757575]
                             shadow-[5px_10px_10px_-6px_rgba(0,0,0,0.3)]
                             ${selectedOption[0].show_name === "" && "h-screen"}
                            `}
        //  h-screen fixed overflow-auto
        style={{
          // background:`linear-gradient( rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.1) ), url(${imgBg})`,
          background: `linear-gradient( rgba(0, 0, 0, 0.0), rgba(0, 0, 0, 0.0) ), url(${imgBg})`,
          backgroundSize: "cover",
        }}
      >
        {/* Header */}
        <div className="flex justify-center mt-0 md:-mt-12 px-2">
          <img src={ednaBlenderLogo} alt="Magid eDNA Blender" width={450} />
        </div>
        <div className="flex-inline justify-center items-baseline text-white mt-20">
          {/* <p className='text-2xl font-bold'>EmotionalDNA® Blender</p> */}
          {/* <p className='mt-24 md:mt-28 text-2xl font-bold'>Use the EmotionalDNA Blender to</p> */}
          <p className="sm:visible md:hidden mt-24 md:mt-28 text-xl font-bold">
            Don't know what to watch tonight?
          </p>
          <p className="md:hidden text-5xl italic mt-4">
            Blend your <br /> favorite content.
          </p>
          <p
            className="invisible h-0 
                                  md:visible md:h-fit
                                  text-[40px] italic"
          >
            What do you feel like watching?
          </p>
        </div>

        {/* Filter */}
        <div className="flex-inline mb-4">
          <div
            className="flex-inline md:flex gap-x-2
                                    mt-8 items-top justify-center"
          >
            <div
              className="flex-inline relative z-20
                                        w-full md:w-1/2
                                        px-12 md:px-0
                                        justify-center"
            >
              <div className="">
                <SelectorMulti
                  filterType="content"
                  options={dbContentList}
                  handleChange={handleSelectorChange}
                  placeholder={
                    'Add two or more shows or movies and press "BLEND IT"...'
                  }
                  value={selectedContent}
                  // width='w-[545px]'
                />
              </div>
              <div
                className="flex justify-start
                                            items-top
                                            text-white text-left text-sm
                                        "
              >
                <Checkbox
                  size="small"
                  checked={incLowChecked}
                  onChange={handleIncLowCheck}
                  sx={{
                    color: "white",
                    "&.Mui-checked": {
                      color: "white",
                    },
                  }}
                />
                <p className="-ml-1 mt-2">
                  Include low reach content in results
                </p>
              </div>
            </div>

            <div className="mt-4 md:mt-1.5 lg:mt-0">
              <button
                type="submit"
                onClick={handleSubmitGo}
                className="w-[110px] px-4 py-2.5 relative z-10 mb-auto
                                            bg-[#3d3935] text-sm font-bold text-white 
                                            shadow-gray-800
                                            shadow-[3px_3px_8px_-1px_rgba(0,0,0,0.3)]
                                            hover:bg-[#ffa300] hover:shadow-lg
                                            focus:outline-none focus:ring-offset-2"
              >
                BLEND IT »
              </button>
            </div>
          </div>
        </div>

        <div ref={ingredientsRef1} />

        {/* Ingredients */}

        {selectedOption[0].show_name !== "" && (
          <div className="flex-inline">
            {/* <div
              className="sm:visible md:invisible md:h-0
                                    px-4
                                    bg-white bg-opacity-70"
            >
              <SimpleSwiper
                selectedOption={selectedOption}
                radarChartData={radarChartData}
                blenderData={blenderData}
                colorCodes={colorCodes}
                onClick={handleCloseBtn}
              />
            </div> */}
            {/* Test section */}
            <IngredSmall
              selectedOption={selectedOption}
              handleCloseBtn={handleCloseBtn}
              blenderData={blenderData}
              radarChartData={radarChartData}
              colorCodes={colorCodes}
              goClicked={goClicked}
              ingredientsListRef={ingredientsListRef}
            />

            {/* End of test section */}
            <div
              className={`invisible md:visible
                                 h-0 md:h-fit
                                 flex flex-wrap 
                                 px-20 pt-6 pb-6 justify-center gap-x-8
                               bg-white bg-opacity-80
                               shadow-black
                               shadow-[5px_-5px_10px_-6px_rgba(0,0,0,0.3)]
                               `}
            >
              {selectedOption.map((option, index) => (
                <div
                  key={[index]}
                  className="sm:flex-inline md:flex items-start"
                >
                  <div className="flex-inline justify-items-center">
                    <UnitIngred
                      ind={index}
                      onClick={(event) => handleCloseBtn(event, index)}
                      option={option}
                      blenderData={blenderData}
                      radarChartData={radarChartData}
                      selectedOption={selectedOption}
                      colorCodes={colorCodes}
                    />
                  </div>
                  <div
                    className="sm:h-[50px] md:h-[320] font-extrabold text-5xl
                                            sm:py-0 md:pt-40
                                            sm:mb-4 md:mb-0
                                            sm:mr-0 md:-mr-6
                                            justify-center"
                  >
                    {index !== selectedOption.length - 1 ? (
                      "+"
                    ) : (
                      <div className="flex gap-x-4 justify-center h-20">
                        <p>=</p>
                        <p className={`${!goClicked && "animate-bounce"}`}>?</p>
                      </div>
                    )}
                  </div>
                </div>
              ))}
              <div ref={ingredientsListRef} className="-mt-48" />
            </div>
            <div className="-mt-8 pb-4">
              {/* What is this */}
              {/* <a
                href={Pdf}
                // href="https://magid.com/emotional-dna/"
                target="_blank"
                rel="noopener noreferrer"
                className="flex gap-x-1 items-center justify-center"
              >
                <BsInfoCircleFill />
                What is this?
              </a> */}
              <WhatIseDNA />
            </div>
          </div>
        )}
      </div>

      <div ref={resultRef} />
      {/* Bottom Part */}
      {/* Blended Radar Charts */}
      {selectedOption[0].show_name !== "" && (
        <div
          className="visible mt-10
                            md:invisible md:h-0"
        >
          <RadarGraphCombo
            data={radarChartDataCombo}
            dataNames={selectedOptionNames}
            showName={"closest show name"}
            refShowName={selectedOption[0].name}
            refShow={true}
            //  returnProximity={blenderData}
            color={colorCodes[0]}
            hideLegend={true}
            labelFontSize={8}
          />
        </div>
      )}

      <div ref={resultPosterRef} />
      <div
        ref={ingredientsRef2}
        className={`${selectedOption[0].show_name !== "" && "mt-6"}`}
      />

      {/* Filters for result */}
      {/* {selectedOption[0].show_name !== "" && ( */}
      {blenderDataAll.length > 1 && (
        <div className="flex-inline">
          <div
            className="flex-inline md:flex mt-8 mb-8 items-top
                                justify-center gap-x-2 px-12"
          >
            <div
              className="flex gap-x-2 gap-y-2 flex-wrap
                                    relative z-50
                                    justify-center md:justify-start"
            >
              <div className="w-96 md:w-56 -mt-5 text-[#53565a] text-sm">
                <div className="flex justify-between px-1.5 mb-0.5 md:mb-0">
                  <div className="flex gap-x-1 items-center">
                    <p className="text-left font-bold">Filter</p>
                    <p className="text-left font-bold invisible md:visible w-0 md:w-fit">
                      by:
                    </p>
                    <BiFilter className="-ml-1.5 text-2xl font-extrabold visible md:invisible md:h-0" />
                  </div>

                  <ViewModeIcons
                    viewMode={viewMode}
                    setViewMode={setViewMode}
                  />
                </div>
                <SelectorMulti
                  filterType={"contentType"}
                  options={dbContentList}
                  handleChange={handleSelectorChangeResultFilter}
                  placeholder="Content Type"
                  styleType="result"
                  value={selectedContentTypeResult}
                  // width='w-52'
                />
              </div>
              <div className="w-96 md:w-56">
                <SelectorMulti
                  filterType={"genre"}
                  // options={dbContentList}
                  options={allGenres}
                  handleChange={handleSelectorChangeResultFilter}
                  placeholder="Genre"
                  styleType="result"
                  value={selectedGenreResult}
                  isDisabled={disableGenreFilter}
                  // width='w-52'
                />
              </div>
              <div className="w-96 md:w-56">
                <SelectorMulti
                  filterType={"network"}
                  options={dbPlatformList}
                  handleChange={handleSelectorChangeResultFilter}
                  placeholder="Network"
                  styleType="result"
                  value={selectedNetworkResult}
                  // width='w-52'
                />
              </div>
              {/* <div className="w-96 md:w-56">
                <SelectorMulti
                  filterType={"rating"}
                  options={dbContentList}
                  handleChange={handleSelectorChangeResultFilter}
                  placeholder="Viewer Rating"
                  styleType="result"
                  value={selectedRatingResult}
                  // width='w-52'
                />
              </div> */}
              <div className="w-96 md:w-56">
                <SelectorMulti
                  filterType={"reach"}
                  options={dbContentList}
                  handleChange={handleSelectorChangeResultFilter}
                  placeholder="Incidence Rate"
                  styleType="result"
                  value={selectedReachResult}
                  // width="w-52"
                />
              </div>

              {/* Top Quartile Checkboxes */}
              <div className="flex items-center gap-x-4 mr-8 text-slate-600 text-xs font-semibold">
                <Checkbox
                  size="small"
                  checked={selectedTopQuartile.contentAcquisition}
                  // onChange={(e) =>
                  //   setSelectedTopQuartile((prev) => ({
                  //     ...prev,
                  //     contentAcquisition: e.target.checked,
                  //   }))
                  // }
                  onChange={handleTopQuartileCheck}
                  name="contentAcquisition"
                  sx={{
                    color: "orange",
                    "&.Mui-checked": { color: "orange" },
                  }}
                />
                <p className="-ml-4">Content Acquisition</p>

                <Checkbox
                  size="small"
                  checked={selectedTopQuartile.evaluation}
                  // onChange={(e) =>
                  //   setSelectedTopQuartile((prev) => ({
                  //     ...prev,
                  //     evaluation: e.target.checked,
                  //   }))
                  // }
                  onChange={handleTopQuartileCheck}
                  name="evaluation"
                  sx={{
                    color: "orange",
                    "&.Mui-checked": { color: "orange" },
                  }}
                />
                <p className="-ml-4">Viewer Rating</p>
              </div>

            </div>

            <div className="flex justify-center">
              <div
                className="mt-4 md:-mt-0.5
                                        w-96 md:w-fit
                                        text-right relative z-40
                                        "
              >
                <button
                  type="submit"
                  onClick={handleClearAll}
                  className="inline-flex justify-center px-4 pt-2.5 pb-2 z-50 mb-auto
                                            items-center gap-x-1 w-[120px]
                                            bg-[#f7f7f7] text-sm font-bold text-[#53565a]
                                            shadow-gray-400 shadow-md
                                            hover:bg-[#ffa300] hover:shadow-lg
                                            focus:outline-none focus:ring-offset-2"
                >
                  Clear all <CgCloseO className="text-lg" />
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* White Gradient at the bottom */}
      {blenderDataDisplay.length > 5 &&
        !(isInViewport1 || isInViewport2 || isInViewport3) && (
          <div className="bg-gradient-to-t from-white fixed bottom-0 h-96 w-screen "></div>
        )}

      {/* Results */}
      {finalResult.length === 0 && <div className="h-96"></div>}
      {blenderDataDisplay[0].show_name !== "" && (
        <div>
          <ViewModeIcons
            pos="md-screen"
            viewMode={viewMode}
            setViewMode={setViewMode}
          />
          {viewMode !== "grid" && (
            <div
              className={`${viewMode !== "grid" ? "visible" : "invisible h-0"}
                                px-1 md:px-20 mt-2`}
            >
              <ResultList data={blenderData} />
            </div>
          )}

          {/* Infinite Scroll */}
          {viewMode === "grid" && (
            <InfiniteScroll
              className={`${viewMode === "grid" ? "visible" : "invisible h-0"}
                                flex flex-wrap 
                                px-2 md:px-20
                                pt-2 pb-6 justify-center gap-x-8`}
              dataLength={blenderDataDisplay.length}
              next={fetchMoreData}
              hasMore={blenderDataDisplay.length !== blenderData.length}
              loader={
                <div className="z-50 w-full h-40 pt-12 mb-20">
                  <BeatLoader color="#bb16a3" speedMultiplier={0.5} />
                </div>
              }
              endMessage={
                <div className="z-50 w-screen h-40 pt-12 mb-8">
                  <p className="text-lg font-bold italic font-[Karla]">
                    🎉 Yay! You have seen it all! 🎉
                  </p>
                </div>
              }
            >
            
              {/* <div className="w-full">
                <ResultFeedback selectedOptionNames={selectedOptionNames} />
              </div> */}
              
              {blenderDataDisplay.map((option, index) => (
                <div key={[index]} className={`flex items-center}`}>
                  <div className="flex-inline justify-items-center">
                    <UnitResult
                      ind={index}
                      option={option}
                      radarChartDataResult={radarChartDataResult}
                      selectedOption={selectedOption}
                      colorCodes={colorCodes}
                    />
                  </div>
                </div>
              ))}
            </InfiniteScroll>
          )}
        </div>
      )}

      {/* End of InfiniteScroll */}

      {/* <div
        className={`${
          !(selectedOption.length > 0 && selectedOption[0].show_name !== "") &&
          "absolute bottom-4"
        } text-left text-sm items-center flex`}
      >
        <Checkbox
          color="default"
          checked={incLowChecked}
          // onChange={handleIncLowCheck}
        />
        Include low reach content
        <p className="italic font-semibold ml-4">
          * Low Reach: Incidence Rate less than 1.5
        </p>
      </div> */}

      <div ref={bottomRef} />

      {/* Loader */}
      {isLoading && (
        <div className="bg-white bg-opacity-60 h-screen w-screen fixed top-0 left-0 z-50 pt-24">
          <SyncLoader color="#bb16a3" speedMultiplier={0.6} />
          <p className="mt-8 animate-bounce text-lg font-extrabold text-[#bb16a3]">
            Blending in progress
          </p>
        </div>
      )}
    </div>
  );
}

export default Blender;
